export const countryFlags: { [key: string]: string } = {
  "ALB": "https://flagcdn.com/al.svg",
  "AND": "https://flagcdn.com/ad.svg",
  "AUT": "https://flagcdn.com/at.svg",
  "BEL": "https://flagcdn.com/be.svg",
  "BGR": "https://flagcdn.com/bg.svg",
  "BIH": "https://flagcdn.com/ba.svg",
  "BLR": "https://flagcdn.com/by.svg",
  "CHE": "https://flagcdn.com/ch.svg",
  "CYP": "https://flagcdn.com/cy.svg",
  "CZE": "https://flagcdn.com/cz.svg",
  "DEU": "https://flagcdn.com/de.svg",
  "DNK": "https://flagcdn.com/dk.svg",
  "ESP": "https://flagcdn.com/es.svg",
  "EST": "https://flagcdn.com/ee.svg",
  "FIN": "https://flagcdn.com/fi.svg",
  "FRA": "https://flagcdn.com/fr.svg",
  "GBR": "https://flagcdn.com/gb.svg",
  "GRC": "https://flagcdn.com/gr.svg",
  "HRV": "https://flagcdn.com/hr.svg",
  "HUN": "https://flagcdn.com/hu.svg",
  "IRL": "https://flagcdn.com/ie.svg",
  "ISL": "https://flagcdn.com/is.svg",
  "ITA": "https://flagcdn.com/it.svg",
  "KOS": "https://flagcdn.com/xk.svg",
  "LIE": "https://flagcdn.com/li.svg",
  "LTU": "https://flagcdn.com/lt.svg",
  "LUX": "https://flagcdn.com/lu.svg",
  "LVA": "https://flagcdn.com/lv.svg",
  "MCO": "https://flagcdn.com/mc.svg",
  "MDA": "https://flagcdn.com/md.svg",
  "MKD": "https://flagcdn.com/mk.svg",
  "MLT": "https://flagcdn.com/mt.svg",
  "MNE": "https://flagcdn.com/me.svg",
  "NLD": "https://flagcdn.com/nl.svg",
  "NOR": "https://flagcdn.com/no.svg",
  "POL": "https://flagcdn.com/pl.svg",
  "PRT": "https://flagcdn.com/pt.svg",
  "ROU": "https://flagcdn.com/ro.svg",
  "RUS": "https://flagcdn.com/ru.svg",
  "SMR": "https://flagcdn.com/sm.svg",
  "SRB": "https://flagcdn.com/rs.svg",
  "SVK": "https://flagcdn.com/sk.svg",
  "SVN": "https://flagcdn.com/si.svg",
  "SWE": "https://flagcdn.com/se.svg",
  "UKR": "https://flagcdn.com/ua.svg",
  "VAT": "https://flagcdn.com/va.svg",
  "TUR": "https://flagcdn.com/tr.svg",
  "AZE": "https://flagcdn.com/az.svg",
  "ARM": "https://flagcdn.com/am.svg",
  "GEO": "https://flagcdn.com/ge.svg",
  "ISR": "https://flagcdn.com/il.svg",
  "FRO": "https://flagcdn.com/fo.svg"
};
